exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".static-content h3 {\n  margin-top: 40px;\n  margin-bottom: 25px;\n}\n@media (max-width: 767px) {\n.static-content h3 {\n      margin-top: 35px;\n      margin-bottom: 10px;\n}\n}\n", ""]);

// exports
